interface SidebarHeaderProps {
  title?: string;
  subTitle?: string;
  description?: string;
}

export const SidebarHeader = ({ title, subTitle, description }: SidebarHeaderProps) => (
  <div className="mb-8 flex flex-col">
    <div className="mb-2">
      <h2 className="text-lg font-bold text-gray-900">{title}</h2>
    </div>
    <div className="flex flex-col gap-1">
      {subTitle && <span className="text-sm font-semibold text-gray-700">{subTitle}</span>}
      {description && (
        <p className="whitespace-pre-line text-sm text-gray-600 transition-opacity duration-200">
          {description}
        </p>
      )}
    </div>
  </div>
);
